import { createSlice } from "@reduxjs/toolkit";

// 輔助函式：生成從 今日整點 往前推 24 小時的資料 (共 25 個點)
const generateTimelineData = (baseValue = 10, variance = 20, isZero = false) => {
  const data = [];
  const now = new Date();

  // 取得當前整點 (例如 11:50 -> 11:00:00)
  const endTime = new Date(now);
  endTime.setMinutes(0, 0, 0, 0);

  // 產生 25 個點：從 0 小時前 (今日整點) 到 24 小時前 (昨日整點)
  for (let i = 0; i <= 24; i++) {
    const time = new Date(endTime.getTime() - i * 3600 * 1000);
    const value = isZero ? 0 : Math.floor(Math.random() * variance) + baseValue;
    data.push([time.toISOString(), value]);
  }

  // 排序：由舊到新
  return data.sort((a, b) => new Date(a[0]) - new Date(b[0]));
};

const deviceReboot = {
  status: "ok",
  msg: "",
  data: {
    allOnlineDevice: 200,
    rebootCount: 2,
    series: generateTimelineData(0, 5)
  }
};

const deviceRebootDevices = {
  status: "ok",
  msg: "",
  data: {
    devices: [
      { deviceName: "AP-General-Office-Cluster", deviceId: "DEV-001", rebootCount: 42 },
      { deviceName: "SW-Distribution-Racks", deviceId: "DEV-002", rebootCount: 32 },
      { deviceName: "AP-Warehouse-High-Density", deviceId: "DEV-003", rebootCount: 30 },
      { deviceName: "AP-Executive-Meeting-Wing", deviceId: "DEV-004", rebootCount: 23 },
      { deviceName: "SW-Core-Chassis-Stack", deviceId: "DEV-005", rebootCount: 18 }
    ]
  }
};

const PoEError = {
  status: "ok",
  msg: "",
  data: {
    errorCounts: { classificationFailure: 0, mpsAbsent: 0, notPoePort: 0, overVoltage: 0, overload: 1, pdShort: 2, powerDenied: 0, startupFailure: 0, thermalShutdown: 0, underVoltage: 0 },
    normalPercent: 92, overloadRiskPercent: 5, failurePercent: 3, totalPoePort: 150, usedPower: 1250, totalPower: 4200
  }
};

const poeErrorPortList = {
  status: "ok",
  msg: "",
  data: {
    devices: [
      { deviceId: "DEV-001", deviceName: "SW-Main-Lobby", portId: 12, errorType: "shortCircuit" },
      { deviceId: "DEV-002", deviceName: "SW-Floor2-West", portId: 4, errorType: "overload" },
      { deviceId: "DEV-003", deviceName: "SW-Access-Core", portId: 0, errorType: "lowVoltage" },
      { deviceId: "DEV-004", deviceName: "SW-Warehouse-01", portId: 48, errorType: "shortCircuit" },
      { deviceId: "DEV-005", deviceName: "SW-Lab-Bench", portId: 2, errorType: "overload" }
    ]
  }
};

const uplinkInstability = {
  status: "ok",
  msg: "",
  data: {
    allOnlineDevice: 145,
    unlinkDevice: 10,
    series: generateTimelineData(2, 8)
  }
};

const uplinkInstabilityDevices = {
  status: "ok",
  msg: "",
  data: {
    devices: [
      { deviceName: "AP-General-Office-Cluster", deviceId: "DEV-001", unlinkCount: 42 },
      { deviceName: "SW-Distribution-Racks", deviceId: "DEV-002", unlinkCount: 32 },
      { deviceName: "AP-Warehouse-High-Density", deviceId: "DEV-003", unlinkCount: 30 },
      { deviceName: "AP-Executive-Meeting-Wing", deviceId: "DEV-004", unlinkCount: 23 },
      { deviceName: "SW-Core-Chassis-Stack", deviceId: "DEV-005", unlinkCount: 18 }
    ]
  }
};

const systemBottleneck = {
  status: "ok",
  msg: "",
  data: {
    allOnlineDevice: 280,
    bottleneckDevice: 10,
    threshold: 70,
    avg: 50,
    series: [5, 2, 3, 12, 4, 5, 6, 3, 1, 2]
  }
};

const systemBottleneckDevices = {
  status: "ok",
  msg: "",
  data: {
    devices: [
      { deviceName: "SW-Distribution-East-01", deviceId: "DEV-101", MaxCpuUsage: 96, MaxMemoryUsage: 92 },
      { deviceName: "AP-Conference-Hall-02", deviceId: "DEV-102", MaxCpuUsage: 88, MaxMemoryUsage: 94 },
      { deviceName: "AP-Guest-Lobby-North", deviceId: "DEV-103", MaxCpuUsage: 42, MaxMemoryUsage: 98 },
      { deviceName: "SW-Access-Floor3-S", deviceId: "DEV-104", MaxCpuUsage: 91, MaxMemoryUsage: 65 },
      { deviceName: "AP-Warehouse-Z4", deviceId: "DEV-105", MaxCpuUsage: 35, MaxMemoryUsage: 40 }
    ]
  }
};

const firmwareStatus = {
  status: "ok",
  msg: "",
  data: {
    latestCount: 95,
    previousCount: 3,
    legacyCount: 2
  }
};

const initialState = {
  deviceReboot,
  deviceRebootDevices,
  PoEError,
  poeErrorPortList,
  uplinkInstability,
  uplinkInstabilityDevices,
  systemBottleneck,
  systemBottleneckDevices,
  firmwareStatus,
};

export const ainsightOperationsSlice = createSlice({
  name: "ainsightOperations",
  initialState,
  reducers: {},
});

export default ainsightOperationsSlice.reducer;
